
(function () {
	'use strict';

	angular.module(modules.homeModule)
		.controller(controllers.homeController, homeController);

	homeController.$inject = ['$scope', '$http', '$state', '$timeout', '$sce', '$location', '$q',
		'favoriteService', 'tabStateService', 'localStorageService', 'resizeService', 'broadcastService', 'documentService',
		'$filter', 'browserService', 'configService'];

	function homeController($scope, $http, $state, $timeout, $sce, $location, $q,
		favoriteService, tabStateService, localStorageService, resizeService, broadcastService, documentService,
		$filter, browserService, configService) {
		var vm = this;

		$scope.translation = globalResources;
		vm.enabledProcessModule = configService.getBool(HandbookConfiguration.EnableProcess);
		vm.annualCycleModuleEnable = configService.getBool(HandbookConfiguration.EnabledAnnualCycle);
		vm.readingListEnabled = configService.getBool(HandbookConfiguration.ReadingListEnabled);
		vm.hearingEnabled = configService.getBool(HandbookConfiguration.HearingEnabled);
		vm.checkHearingTab = false;

		vm.commonGridSettingKey = gridSettingKeys.commonVisibilitySettings;
		vm.readingListGridSettingKey = gridSettingKeys.readingListVisibilitySettings;
		vm.groupDocumentAnchorPrefix = prefix.groupDocumentAnchorPrefix;

		vm.loadWhatNew = loadWhatNew;
		vm.loadFavorite = loadFavorite;
		vm.loadReadingDocumentsLists = loadReadingDocumentsLists;
		vm.loadHearingDocuments = loadHearingDocuments;
		vm.hearingRowClick = hearingRowClick;
		vm.onRowClick = onRowClick;
		vm.adjustMenuPosition = adjustMenuPosition;
		vm.ajustmentNews = ajustmentNews;
		vm.goToRegisterDeviation = goToRegisterDeviation;
		vm.goToChecklist = goToChecklist;
		vm.goToAnnualCycle = goToAnnualCycle;
		vm.goToRiskModule = goToRiskModule;
		vm.viewReport = viewReport;
		vm.clickNavTab = clickNavTab;

		vm.hearingGridSetting = [];
		vm.HearingsSetting = [];
		vm.readingList = [];
		vm.allReadingDocuments = [];
		vm.processAwaitingHearings = [];
		vm.processPublicHearings = [];
		vm.aWaitingHearings = [];
		vm.publicHearings = [];
		vm.selectedTab = "";

		vm.messageWhatNew = String.format(globalResources.RecentlyApprovedDocumentsInTheHandbook, globalResources.AllFolders);

		vm.normalStartpage = HandbookConfiguration.StartpageThemeKey == E.StartpageTheme.Normal;

		vm.changeSelectedOption = changeSelectedOption;
		vm.publishedVersion = configService.getBool(HandbookConfiguration.PublishedVersion);

		var BACKEND_URL = HandbookConfiguration.BackendURL;

		function getBackendUrl() {
			const url = new URL(BACKEND_URL);
			url.protocol = $location.protocol();
			return url.href;
		}

		var lastChar = BACKEND_URL.charAt(BACKEND_URL.length - 1);
		var commonAdd = lastChar == '/' ? '' : '/';
		vm.columnNotRemove = 'name';
		vm.BROWSER_TYPE = BrowserType;
		vm.browserType = browserService.detectBrowserWindow();
		vm.periodWhatNewOptions = [
			{ id: 0, name: globalResources.Today },
			{ id: 1, name: globalResources.LastWeek },
			{ id: 2, name: globalResources.LastMonth },
			{ id: 3, name: globalResources.Last3Months }
		];

		vm.whatNewData = [
			{ id: 0, name: globalResources.Today, data: [] },
			{ id: 1, name: globalResources.LastWeek, data: [] },
			{ id: 2, name: globalResources.LastMonth, data: [] },
			{ id: 3, name: globalResources.Last3Months, data: [] }
		];

		vm.summaryNewData =
		{
			totalWhatNews: 0,
			totalFavorities: 0,
			totalReadingDocuments: 0,
			totalMissingReadingDocuments: 0,
			totalAwaitingHearings: 0,
			totalPublicHearings: 0
		};
		vm.WhatsNewCountConfig = parseInt(HandbookConfiguration.WhatsNewCount);
		vm.UpdatedFavoritesCountConfig = parseInt(HandbookConfiguration.UpdatedFavoritesCount);

		function buildHearingsGridSetting() {
			var nameFolder = vm.enabledProcessModule ? $scope.translation.CommonGridColumns.Chapter + '/' + $scope.translation.CommonGridColumns.ProcessArea
				: $scope.translation.CommonGridColumns.Chapter;
			vm.hearingGridSetting.push({ id: 'information', name: '', width: '20px', coldefault: true });
			vm.hearingGridSetting.push({ id: 'name', name: $scope.translation.CommonGridColumns.Title, width: 50, coldefault: true });
			vm.hearingGridSetting.push({ id: 'dueDate', name: $scope.translation.HearingDueDate, width: 22, coldefault: true, customCss: 'min-width-90', type: COLUMN_DATA_TYPES.STRING_DATE });
			vm.hearingGridSetting.push({ id: 'isPublic', name: $scope.translation.Public, width: 5, coldefault: true, customCss: 'min-width-45' });
			vm.hearingGridSetting.push({ id: 'folderName', name: nameFolder, width: 26, coldefault: true });
			vm.hearingGridSetting.push({ id: 'version', name: $scope.translation.CommonGridColumns.Version, width: '90px', coldefault: true, customCss: 'align-right' });
			vm.hearingGridSetting.push({ id: 'documentId', name: $scope.translation.CommonGridColumns.DocumentId, width: '60px', coldefault: true, customCss: 'align-right' });
			vm.hearingGridSetting.push({ id: 'responsible', name: $scope.translation.CommonGridColumns.Responsible, width: 20, coldefault: true });
		}

		var url = angular.copy($location.$$url);
		url = url.toLowerCase();
		if (url.indexOf('checklist-fe') > -1) {
			//triggerTabClicked('#checklist-tab', true);
			goTochecklistFromUrl(url);
		} else if (url.indexOf('/ac/') > -1) {
			goToAnnualCycleFromUrl(url);
		}

		initialize();

		function initialize() {

			var storageWhatsNewPeriodAll = localStorageService.getItem("WhatsNewPeriodAll");
			vm.selectedOption = storageWhatsNewPeriodAll != null ? parseInt(storageWhatsNewPeriodAll) : parseInt(HandbookConfiguration.WhatsNewPeriodAll);

			if (vm.hearingEnabled) {
				buildHearingsGridSetting();
				vm.HearingsSetting = angular.copy(vm.hearingGridSetting);
				vm.HearingsSetting[0].name = $scope.translation.CommonGridColumns.DocumentInfo;
			}
			resizeService.resizeView();
			gridConfiguration();
			detectBrowser();
			angular.element(prefix.hashbangPrefix + 'homeTabs li').removeClass(cssClass.active);

			var mandatatoryRequests = [
				$http.get("/api/UserDocuments/GetDocumentSummaryNewData", { params: { periodOption: vm.selectedOption } })
			];
			if (vm.enabledProcessModule) {
				mandatatoryRequests.push($http.get("/api/CombineDocumentAndProcess/GetProcessSummaryNewData", { params: { periodOption: vm.selectedOption } }));
			}

			$q.all(mandatatoryRequests).then(function (response) {
				if (!response || response.length < mandatatoryRequests.length || !response[0].data) return;
				var sum_Document = response[0].data;
				var sum_Process = {
					totalWhatNews: 0,
					totalFavorities: 0,
					totalReadingDocuments: 0,
					totalMissingReadingDocuments: 0,
					totalAwaitingHearings: 0,
					totalPublicHearings: 0
				};;

				if (vm.enabledProcessModule) {
					if (!response[1].data) return;
					sum_Process = response[1].data;
				}

				vm.summaryNewData =
				{
					totalWhatNews: sum_Document.totalWhatNews + sum_Process.totalWhatNews,
					totalFavorities: sum_Document.totalFavorities + sum_Process.totalFavorities,
					totalReadingDocuments: sum_Document.totalReadingDocuments + sum_Process.totalReadingDocuments,
					totalMissingReadingDocuments: sum_Document.totalMissingReadingDocuments + sum_Process.totalMissingReadingDocuments,
					totalAwaitingHearings: sum_Document.totalAwaitingHearings + sum_Process.totalAwaitingHearings,
					totalPublicHearings: sum_Document.totalPublicHearings + sum_Process.totalPublicHearings
				};

				if (vm.summaryNewData.totalWhatNews > vm.WhatsNewCountConfig)
					vm.summaryNewData.totalWhatNews = vm.WhatsNewCountConfig;

				if (vm.summaryNewData.totalFavorities > vm.UpdatedFavoritesCountConfig)
					vm.summaryNewData.totalFavorities = vm.UpdatedFavoritesCountConfig;

				vm.checkHearingTab = (vm.summaryNewData.totalAwaitingHearings + vm.summaryNewData.totalPublicHearings) > 0; // if summary have AwaitingHearings or PublicHearings enable hearingTab

				if (vm.readingListEnabled && (vm.summaryNewData.totalReadingDocuments > 0 && vm.summaryNewData.totalMissingReadingDocuments == 0))
					vm.selectedTab = "reading-lists-tab";

				if (vm.annualCycleModuleEnable && (vm.summaryNewData.totalReadingDocuments <= 0 && vm.summaryNewData.totalMissingReadingDocuments <= 0))
					vm.selectedTab = "new-annual-cycle-tab";

				handleNavigate();
				setTimeout(function () {
					setTabPanelActive();
				});
			});

			if (HandbookConfiguration.StartpageThemeKey == E.StartpageTheme.Normal) {
				tabStateService.adjustContentHeightHomeStartPageTab();
			}

			$scope.$on('annualCyclesLength', function (e, arg) {
				if (vm.annualCycleModuleEnable) {

					var url = $location.$$url;
					if (!url)
						return;
					url = url.toLowerCase();

					if (url.indexOf('tab?') == -1) {
						return;
					}

					if (url.indexOf('mypage') > -1 && url.indexOf('annualcycle') > -1 && vm.annualCycleModuleEnable) {
						setTimeout(function () {
							triggerTabClicked('#reading-list-tab', true);
							triggerTabClicked('#annual-cycle-tab', false);
						});
					}
				}
			});
		}

		$(window).on('resize', function () {
			vm.browserType = browserService.detectBrowserWindow();
		});

		function viewReport() {
			$state.go(handbookActions.MyReadingListsReport, {});
		};

		function clickNavTab(tab) {
			vm.selectedTab = tab;
		};

		function handleNavigate() {
			var url = angular.copy($location.$$url);
			if (!url)
				return;
			url = url.toLowerCase();

			if (url.indexOf('checklist-fe') > -1) {
				triggerTabClicked('#checklist-tab', true);
				return;
			}

			if (url.indexOf('ac') > -1) {
				triggerTabClicked('#new-annual-cycle-tab', true);
				return;
			}

			if (url.indexOf('tab?') == -1) {
				return;
			}

			if (url.indexOf('whatsnew') > -1) {
				triggerTabClicked('#what-new-tab', true);
			} else if (url.indexOf('updatedfavorites') > -1) {

				triggerTabClicked('#favorite-tab', true);
			} else if (url.indexOf('mypage') > -1) {
				if (vm.readingListEnabled &&
					((url.indexOf('readinglist') > -1 && vm.summaryNewData.totalReadingDocuments > 0)
						|| (url.indexOf('missingreadingreceipts') > -1 && vm.summaryNewData.totalMissingReadingDocuments > 0))) {
					triggerTabClicked('#reading-list-tab', true);
				} else {
					triggerTabClicked('#master-tab', true);
				}
				if (vm.readingListEnabled && url.indexOf('readinglist') > -1
					&& vm.summaryNewData.totalReadingDocuments > 0) {
					triggerTabClicked('#reading-lists-tab', false);
				}

				if (vm.readingListEnabled && url.indexOf('missingreadingreceipts') > -1
					&& vm.summaryNewData.totalMissingReadingDocuments > 0) {
					triggerTabClicked('#missing-reading-tab', false);
				}
			} else if (url.indexOf('home') > -1) {
				triggerTabClicked('#master-tab', true);
			} else if (url.indexOf('tohearing') > -1) {
				if ((vm.summaryNewData.totalAwaitingHearings > 0 && url.indexOf('awaitinghearing') > -1)
					|| (vm.summaryNewData.totalPublicHearings > 0 && url.indexOf('publichearings') > -1)) {
					triggerTabClicked('#hearings-tab', true);
				} else {
					triggerTabClicked('#master-tab', true);
				}
				if (vm.summaryNewData.totalAwaitingHearings > 0 && url.indexOf('awaitinghearing') > -1) {
					triggerTabClicked('#aWaitingHearingstab', false);
				}
				if (vm.summaryNewData.totalPublicHearings > 0 && url.indexOf('publichearings') > -1) {
					triggerTabClicked('#publicHearingstab', false);
				}
			}

		}

		function triggerTabClicked(tabId, clickItSelf) {
			setTimeout(function () {
				var childTab = $(tabId + ' a');
				if (childTab) {
					$(childTab).click();
					if (clickItSelf && $(tabId)) {
						$(tabId).click();
					}
				}
			});
		}

		function changeSelectedOption() {
			localStorageService.setItem("WhatsNewPeriodAll", vm.selectedOption);
			loadWhatNew();
		}

		function ajustmentNews() {
			broadcastService('adjustmentNews', {});
		}

		function updateNewestDocuments(documents, type) {
			var storageObject = localStorageService.getItem(localStorageKeys.readDocuments);
			var readDocuments = [];
			if (storageObject != null) {
				readDocuments = JSON.parse(storageObject);
			}
			var count = 0
			if (documents != null) {
				for (var i = 0; i < documents.length; i++) {
					for (var j = 0; j < readDocuments.length; j++) {
						if (documents[i].id == readDocuments[j].id
							&& documents[i].longApprovedDate == readDocuments[j].approvedDate
							&& documents[i].isNew) {
							count += 1;
							documents[i].isNew = false;
						}
					}
				}
			}

			if (count > 0) {
				switch (type) {
					case 1: // what's new
						vm.summaryNewData.totalWhatNews -= count;
						break;
					case 2: // updated favorite
						vm.summaryNewData.totalFavorities -= count;
						break;
				}
			}
		}

		function detectBrowser() {
			var ieVersion = msieversion();
			if (ieVersion > 0 && ieVersion < 9) {
				vm.unsupportBrowserMessage = $sce.trustAsHtml(String.format(globalResources.UnsupportedBrowser + '<a href="' + HandbookConfiguration.OldHandbookUrl + '"' + '>' + HandbookConfiguration.OldHandbookUrl + '</a>'));
				angular.element('#sidebar-wrapper').addClass('toggle-sidebar');
				angular.element('#resizeBar').addClass('toggle-sidebar');
				angular.element('#wrapper').addClass('toggle-wrapper');
				angular.element('.tabbable').addClass('toggle-mainview');
				$state.go(handbookActions.UnsupportBrowser, {});
			}
		}

		function gridConfiguration() {
			getGridSetting(vm.commonGridSettingKey);
			getColumnsDefinition(vm.commonGridSettingKey);
			vm.commonColumnsDefinition = angular.copy(optionalColumnsDenifinition);

			getGridSetting(vm.readingListGridSettingKey);
			getColumnsDefinition(vm.readingListGridSettingKey);
			vm.readingListColumnsDefinition = angular.copy(optionalColumnsDenifinition);
		}

		function loadWhatNew() {
			if (vm.whatNewData[vm.selectedOption].data && vm.whatNewData[vm.selectedOption].data.length > 0)
				return;

			if (vm.enabledProcessModule) {
				return $http
					.get(handbookRequests.GetRecentlyApprovedDocumentsProcessesRequest, { params: { periodOption: vm.selectedOption, showLoading: true } })
					.success(function (data) {
						if (data) {
							vm.whatNewData[vm.selectedOption].data = data;
							documentService.getAgreeFilesForDocuments(vm.whatNewData[vm.selectedOption].data);
							updateTotalWhatNew();
							updateNewestDocuments(vm.whatNewData[vm.selectedOption].data, 1);
							updateAttachmentsForDocuments(vm.whatNewData[vm.selectedOption].data);
							updateAttachmentsForProcesses(vm.whatNewData[vm.selectedOption].data);
							vm.periodWhatNewOptions[vm.selectedOption].isLoaded = true;
						}
					});
			}
			return $http.get(handbookRequests.GetRecentlyApprovedDocumentsRequest, { params: { periodOption: vm.selectedOption, showLoading: true } })
				.success(function (data, status, headers, config) {
					vm.whatNewData[vm.selectedOption].data = data;
					updateAttachmentsForDocuments(vm.whatNewData[vm.selectedOption].data);
					documentService.getAgreeFilesForDocuments(vm.whatNewData[vm.selectedOption].data);
					updateTotalWhatNew();
					updateNewestDocuments(vm.whatNewData[vm.selectedOption].data, 1);
				});
		}

		function updateTotalWhatNew() {
			vm.summaryNewData.totalWhatNews = getNewCount(vm.whatNewData[vm.selectedOption].data);
		}

		function loadFavorite() {
			if (vm.favoriteData && vm.favoriteData.length > 0)
				return;

			if (vm.enabledProcessModule) {
				return $http
					.get(handbookRequests.GetProcessAndDocumentLatestFavoriteRequest, {
						params: {
							showLoading: true
						}
					})
					.success(function (data) {
						if (data) {
							vm.favoriteData = data ? data.filter(x => !x.hidden) : null;
							documentService.getAgreeFilesForDocuments(vm.favoriteData);
							updateTotalNewestFavorites();
							updateNewestDocuments(vm.favoriteData, 2);
							updateAttachmentsForDocuments(vm.favoriteData);
							updateAttachmentsForProcesses(vm.favoriteData);
						}
					});
			}
			return $http
				.get(handbookRequests.GetLatestFavoriteRequest, {
					params: {
						showLoading: true
					}
				})
				.success(function (data, status, headers, config) {
					vm.favoriteData = data ? data.filter(x => !x.hidden) : null;
					updateAttachmentsForDocuments(vm.favoriteData);
					documentService.getAgreeFilesForDocuments(vm.favoriteData);
					updateTotalNewestFavorites();
					updateNewestDocuments(vm.favoriteData, 2);
				});
		}

		function loadReadingDocumentsLists() {
			if (!vm.readingListEnabled) {
				return;
			}

			if (vm.allReadingDocuments && vm.allReadingDocuments.length > 0)
				return;

			if (vm.enabledProcessModule) {
				return $http
					.get('/api/CombineDocumentAndProcess/GetReadingDocumentsAndProcessesList', {
						params: {
							showLoading: true
						}
					})
					.success(function (data) {
						if (data && data.length) {
							data.forEach(function (item) {
								if (item.confirmDate) {
									if (item.readingReceiptsExpire) {
										item.tooltipExpired = String.format(globalResources.TooltipReadingReceiptsExpired, item.confirmDate, item.readingReceiptValidity);
									} else {
										item.tooltipExpired = String.format(globalResources.TooltipReadingReceiptsNoExpired, item.confirmDate);
									}
								}
							});
							updateAttachmentsForDocuments(data);
							updateAttachmentsForProcesses(data);
						}

						(data || []).forEach(function (item) {
							//todo: compare with id instead
							var existing = vm.readingList.filter(function (d) {
								return d.readingListId == item.readingListId;
							});

							if (!existing || !existing.length) {
								vm.readingList.push({
									readingListId: item.readingListId,
									readingListName: item.readingListName,
									readingReceiptValidity: item.readingReceiptValidity,
									readingReceiptsExpire: item.readingReceiptsExpire,
									readingListCreatedDate: item.readingListCreatedDate,
									readingListUpdatedDate: item.readingListUpdatedDate,
									readingListCreatedBy: item.readingListCreatedBy,
									readingListUpdatedBy: item.readingListUpdatedBy,
									readingListDescription: item.readingListDescription
								});
							}
						});

						vm.allReadingDocuments = decorateDocumentReadingListName(data);
						vm.summaryNewData.totalReadingDocuments = vm.allReadingDocuments.length;

						updateAttachmentsForDocuments(vm.allReadingDocuments)
						updateAttachmentsForProcesses(vm.allReadingDocuments)
						vm.documentsGroups = getDocumentGroupsByReadingListId(vm.allReadingDocuments);
						vm.missingReadingDocuments = getMissingReadingDocuments(vm.allReadingDocuments);
						vm.summaryNewData.totalMissingReadingDocuments = vm.missingReadingDocuments.length;

						vm.documentsGroups.forEach(function (item) {
							item.tooltips = generateReadingListTooltip(item);
						});
					});
			}
			else {
				return $http
					.get('/api/UserDocuments/GetReadingDocumentsList', {
						params: {
							showLoading: true
						}
					})
					.success(function (data) {
						if (data && data.length) {
							data.forEach(function (item) {
								if (item.confirmDate) {
									if (item.readingReceiptsExpire) {
										item.tooltipExpired = String.format(globalResources.TooltipReadingReceiptsExpired, item.confirmDate, item.readingReceiptValidity);
									} else {
										item.tooltipExpired = String.format(globalResources.TooltipReadingReceiptsNoExpired, item.confirmDate);
									}
								}
							});
						}

						(data || []).forEach(function (document) {
							//todo: compare with id instead
							var existing = vm.readingList.filter(function (d) {
								return d.readingListId == document.readingListId;
							});

							if (!existing || !existing.length) {
								vm.readingList.push({
									readingListId: document.readingListId,
									readingListName: document.readingListName,
									readingReceiptValidity: document.readingReceiptValidity,
									readingReceiptsExpire: document.readingReceiptsExpire,
									readingListCreatedDate: document.readingListCreatedDate,
									readingListUpdatedDate: document.readingListUpdatedDate,
									readingListCreatedBy: document.readingListCreatedBy,
									readingListUpdatedBy: document.readingListUpdatedBy,
									readingListDescription: document.readingListDescription
								});
							}
						});
						vm.allReadingDocuments = decorateDocumentReadingListName(angular.copy(data));
						vm.summaryNewData.totalReadingDocuments = vm.allReadingDocuments.length;

						updateAttachmentsForDocuments(vm.allReadingDocuments)
						vm.documentsGroups = getDocumentGroupsByReadingListId(vm.allReadingDocuments);
						vm.missingReadingDocuments = getMissingReadingDocuments(vm.allReadingDocuments);
						vm.summaryNewData.totalMissingReadingDocuments = vm.missingReadingDocuments.length;

						vm.documentsGroups.forEach(function (item) {
							item.tooltips = generateReadingListTooltip(item);
						});
					});
			}
		}

		function generateReadingListTooltip(row) {

			var groups = vm.readingList.filter(function (d) {
				return d.readingListName == row.templateName;
			});

			var group = groups[0];
			var result = "<div class='table-css'>";

			result += getElementForTooltips(globalResources.Name, group.readingListName);
			var createdDate = (group.readingListCreatedDate != null && group.readingListCreatedDate != 'null') ? group.readingListCreatedDate : '';
			var updatedDate = (group.readingListUpdatedDate != null && group.readingListUpdatedDate != 'null') ? group.readingListUpdatedDate : '';
			result += getElementForTooltips(globalResources.CreatedDate, createdDate);
			result += getElementForTooltips(globalResources.CreatedBy, group.readingListCreatedBy);
			result += getElementForTooltips(globalResources.UpdatedDate, updatedDate);
			result += getElementForTooltips(globalResources.UpdatedBy, group.readingListUpdatedBy);
			if (group.readingReceiptsExpire) {

				result += getElementForTooltips(globalResources.Validity, group.readingReceiptValidity + " " + globalResources.Months);
			}
			result += getElementForTooltips(globalResources.Description, group.readingListDescription);
			result += "    </div>";
			return result;
		}

		function loadHearingDocuments() {
			if (!vm.hearingEnabled)
				return;
			if ((vm.aWaitingHearings && vm.aWaitingHearings.length > 0) || (vm.publicHearings && vm.publicHearings.length > 0))
				return;

			var params = {
				params: {
					pageIndex: 0,
					pageSize: 0,
					showLoading: true
				}
			};
			return $http.get(handbookRequests.GetHearingDocumentsRequest, params)
				.success(function (data, status, headers, config) {
					if (data) {
						vm.aWaitingHearings = data.awaitingHearings ? data.awaitingHearings.filter(x => !x.hidden) : [];
						vm.publicHearings = data.publicHearings ? data.publicHearings.filter(x => !x.hidden) : [];

						vm.aWaitingHearings.forEach(function (item) {
							item.information = _buildDocumentTooltip(item);
							item.isPublic = item.isPublic ? globalResources.Yes : globalResources.No;
							item.folderName = '<img src="' + item.folderIcon + '">' + item.folderName;
						});

						vm.publicHearings.forEach(function (item) {
							item.information = _buildDocumentTooltip(item);
							item.isPublic = item.isPublic ? globalResources.Yes : globalResources.No;
							item.folderName = '<img src="' + item.folderIcon + '">' + item.folderName;
						});

						loadHearingProcesses();
					}
				});
		}

		function loadHearingProcesses() {
			if (!vm.enabledProcessModule) return;

			getProcessAwaitingHearings();
			getProcessPublicHearings();
		}

		function getProcessAwaitingHearings() {
			$http
				.get(handbookRequests.GetProcessAwaitingHearing, {
					params: {
						showLoading: true
					}
				})
				.success(function (data, status, headers, config) {
					if (data) {
						vm.processAwaitingHearings = data;
						combineProcessHearings(vm.aWaitingHearings, vm.processAwaitingHearings);
						setTimeout(function () {
							vm.checkHearingTab = vm.aWaitingHearings.length || vm.publicHearings.length;
						})
					}
				});
		}

		function getProcessPublicHearings() {
			$http
				.get(handbookRequests.GetProcessPublicHearing, {
					params: {
						showLoading: true
					}
				})
				.success(function (data, status, headers, config) {
					if (data) {
						vm.processPublicHearings = data;
						combineProcessHearings(vm.publicHearings, vm.processPublicHearings);
						setTimeout(function () {
							vm.checkHearingTab = vm.aWaitingHearings.length || vm.publicHearings.length;
						})
					}
				});
		}

		function combineProcessHearings(documents, processes) {
			if (processes) {
				processes.forEach(function (p) {
					var d = {
						agreeFiles: [],
						approvalStatus: "Hearing",
						approvedBy: p.approvedBy,
						approvedDate: p.approvedDate,
						approverResponsible: null,
						attachments: null,
						chapterLevel: 0,
						createdDate: p.createdDate,
						deleted: p.deleted,
						documentIcon: "typcn typcn-document-text",
						documentId: p.id,
						documentStatus: 3,
						draft: p.IsDraft,
						dueDate: p.dueDate,
						dueDateDisplay: null,
						entityId: p.entityId,
						expirationDate: null,
						expired: false,
						expiredDate: p.expiredDate,
						feedBackCount: 0,
						feedBackDislike: 0,
						feedBackLike: 0,
						feedBackNull: 0,
						folderIcon: "f-normal typcn typcn-folder",
						areaId: p.areaId,
						folderName: '<span class="fs18 areas-color ng-scope fa fa-folder"></span> ' + p.folderName,
						handbookId: 0,
						hasAgreeFiles: false,
						hasAttachment: false,
						id: p.id,
						internetDocument: p.internetDocument,
						isAddNewVirtual: false,
						isHearing: false,
						isPublic: p.isPublic ? 'Yes' : 'No',
						knowledgeTypeId: 0,
						lastContentEdit: "",
						location: p.location,
						metatagValue: null,
						name: p.name,
						order: p.order,
						orgiginApprovedDate: null,
						orgiginPublishedDate: p.publishedDate,
						permissions: null,
						publishedDate: p.publishedDate,
						readCount: 0,
						registerItemItemId: 0,
						responsible: p.responsible,
						responsibleId: p.responsibleId,
						template: null,
						templateId: null,
						type: 0,
						updatedDate: p.updatedDate,
						version: p.version,
						virtual: false,
						isProcess: p.isProcess
					};
					documents.push(d);
				});

				documents.sort(function (x, y) {
					var d1 = x.dueDate.toString().substr(6, 4) + x.dueDate.toString().substr(3, 2) + x.dueDate.toString().substr(0, 2);
					var d2 = y.dueDate.toString().substr(6, 4) + y.dueDate.toString().substr(3, 2) + y.dueDate.toString().substr(0, 2);
					return d1 > d2 ? -1 : (d1 == d2 ? 0 : 1);
				});

			}
		}

		function _buildDocumentTooltip(row) {
			var tooltipData = [];
			tooltipData.push({ label: globalResources.LinkedVirtually, data: row.virtual ? globalResources.Yes : globalResources.No });
			tooltipData.push({ label: globalResources.CommonGridColumns.Title, data: row.name });
			tooltipData.push({ label: globalResources.CommonGridColumns.Type, data: row.template });
			tooltipData.push({ label: row.isProcess ? globalResources.ProcessArea : globalResources.CommonGridColumns.Chapter, data: row.folderName });
			tooltipData.push({ label: globalResources.CommonGridColumns.Location, data: row.location });
			tooltipData.push({ label: globalResources.CommonGridColumns.Version, data: row.version });
			tooltipData.push({ label: globalResources.CommonGridColumns.DocumentId, data: row.documentId });
			tooltipData.push({ label: globalResources.CommonGridColumns.ApprovedDate, data: row.approvedDate });
			if (!vm.publishedVersion) {
				tooltipData.push({ label: globalResources.CommonGridColumns.Approver, data: row.approvedBy });
				tooltipData.push({ label: globalResources.CommonGridColumns.Responsible, data: row.responsible });
			}
			return tooltipData;
		}

		function hearingRowClick(id, isProcess = false, version) {
			var linkDirect = isProcess ? urlOpenProcessHearing : urlOpenHearingFeedback;
			//redirect to hearing feedback page
			if (isProcess) {
				window.open(String.format(linkDirect, String(id), String(version)));
			} else {
				window.open(String.format(linkDirect, String(id)));
			}
		}

		function getMissingReadingDocuments(documents) {
			documentService.getAgreeFilesForDocuments(documents);
			var isConfirmId = [];
			documents.forEach((document) => {
				if (document.isConfirmed) {
					isConfirmId.push(document.documentId);
				}
			});

			var documentsNotConfirm = [];
			documents.forEach((document) => {
				const existing = isConfirmId.find(function (id) {
					return id === document.documentId;
				});

				if (!existing) {
					documentsNotConfirm.push(document);
				}
			});

			var distinctDocumentId = [];
			var missingDocuments = [];
			documentsNotConfirm.forEach((document) => {
				var existing = distinctDocumentId.find(function (id) {
					return id === document.documentId;
				});

				if (!existing) {
					distinctDocumentId.push(document.documentId);
					missingDocuments.push(document);
				}
			});

			return missingDocuments;
		}

		function getDocumentGroupsByReadingListId(documents) {

			if (!vm.readingList || !vm.readingList.length) {
				return [];
			}

			if (!documents || !documents.length) {
				return [];
			}
			var documentsGroups = [];
			for (var i = 0; i < vm.readingList.length; i++) {
				var readingList = vm.readingList[i];
				var documentsOfEachReadingList = [];
				documents.forEach(function (item) {
					if (item.readingListId == readingList.readingListId) {
						documentsOfEachReadingList.push(item);
					}
				});
				if (documentsOfEachReadingList.length) {
					documentsGroups.push({
						documents: documentsOfEachReadingList,
						templateName: readingList.readingListName,
						totalDocuments: documentsOfEachReadingList.length
					});
				}
			}
			for (var i = 0; i < documentsGroups.length; i++) {
				documentsGroups[i].documents = $filter('orderBy')(documentsGroups[i].documents, ['sort', 'name']);
			}
			return documentsGroups;
		}

		function decorateDocumentReadingListName(documents) {
			var results = [];
			for (var i = 0; i < documents.length; i++) {
				var document = documents[i];
				var existing = results.filter(function (item) {
					return item.documentId == document.documentId;
				});
				if (existing.length) {
					var existingIndex = results.indexOf(existing[0]);
					results[existingIndex].readingListName = (results[existingIndex].readingListName + ", ").concat(document.readingListName);
					document.readingListName = results[existingIndex].readingListName;
				}
				results.push(document);
			}
			return results;
		}

		function getDistinctItems(items) {
			var distincItems = [];
			items.forEach(function (item) {
				var existing = distincItems.filter(function (v, i) {
					return v === item;
				});
				if (!existing.length) {
					distincItems.push(item);
				}
			});
			return distincItems;
		}

		function updateTotalNewestFavorites() {
			vm.summaryNewData.totalFavorities = getNewCount(vm.favoriteData);
		}

		function getNewCount(data) {
			var countItemNew = 0;
			(data || []).forEach(function (item) {
				if (item.isNew) {
					countItemNew += 1;
				}
			});
			return countItemNew;
		}

		function adjustContentPosition() {
			var tabState = tabStateService.getState(tabStateType.homeTabState);
			$timeout(function () {
				tabStateService.adjustContentPosition(tabState, tabStateType.homeTabState);
			}, 0, false);
		}

		function onRowClick($event) {
			favoriteService.setFavoriteNodeState({ isFavorited: false });
			documentService.goToDocument($event);
		}

		function adjustMenuPosition(toggleSidebar, tabId) {
			// Extra processing for 'Updated Favorite' and What's new tab. It depends on the sidebar toggle.
			if (tabId == homeTabs.updatedFavorite) {
				var updateFavoritePrintbox = angular.element('#' + homeContent.updatedFavoritePage + ' #print-box2');
				if (toggleSidebar == true) {
					updateFavoritePrintbox.removeClass(avoidCustomPageClass);
				} else {
					updateFavoritePrintbox.addClass(avoidCustomPageClass);
				}
			} else if (tabId == homeTabs.whatNew) {
				var whatNewPrintbox = angular.element('#' + homeContent.whatNewPage + ' #print-box2');
				if (toggleSidebar == true) {
					whatNewPrintbox.removeClass(avoidCustomPageClass);
				} else {
					whatNewPrintbox.addClass(avoidCustomPageClass);
				}
			}
		}

		function updateAttachmentsForDocuments(documents) {
			var documentIds = [];
			for (var i = 0; i < documents.length; i++) {
				if (documents[i].hasAttachment && !documents[i].isProcess) {
					documentIds.push(documents[i].id);
				}
			}
			documentIds = getDistinctItems(documentIds);
			if (documentIds.length) {
				$http
					.post('/api/Documents/GetAttachmentsForDocuments', { documentIds: documentIds })
					.success(function (data) {
						if (data && data.length) {
							data.forEach(function (x) {
								x.itemId = x.extraId ? x.extraId : x.itemId;
							});
						}
						for (var i = 0; i < documents.length; i++) {
							if (documents[i].hasAttachment && !documents[i].isProcess) {
								documents[i].attachments = [];
								for (var j = 0; j < data.length; j++) {
									if (data[j].documentId == documents[i].id) {
										documents[i].attachments.push(data[j]);
									}
								}
							}
						}
					});
			}
		}

		function updateAttachmentsForProcesses(processes) {
			if (!processes || !processes.length) {
				return null;
			}

			var processEntityIds = [];
			for (var i = 0; i < processes.length; i++) {
				if (processes[i].hasAttachment && processes[i].isProcess) {
					processEntityIds.push(processes[i].entityId);
				}
			}

			processEntityIds = getDistinctItems(processEntityIds);
			if (processEntityIds.length) {
				$http.get('/api/Processes/GetAttachmentsForProcesses', {
					params: { processEntityIds },
				})
					.success(function (data) {
						if (data && data.length) {
							data.forEach(x => {
								x.itemId = x.extraId ? x.extraId : x.itemId;
							});
						}
						for (var i = 0; i < processes.length; i++) {
							if (processes[i].hasAttachment && processes[i].isProcess) {
								processes[i].attachments = [];
								processes[i].attachmentHtml = '';
								for (var j = 0; j < data.length; j++) {
									if (data[j].processEntityId === processes[i].entityId) {
										processes[i].attachments.push(data[j]);
									}
								}
							}
						}
					});
			}

		}

		function goToRegisterDeviation() {
			window.open(HandbookConfiguration.DeviationUrl);
		}

		function goToRiskModule() {
			window.open(getBackendUrl() + commonAdd + 'rm');
		}

		function goToChecklist() {
			var url = angular.copy($location.$$url);
			url = url.toLowerCase();
			if (url.indexOf('checklist') > -1) {
				return;
			}
			vm.linkToChecklist = $sce.trustAsResourceUrl(commonAdd + 'checklist/category/main?isHideTopbar');
		}

		function goTochecklistFromUrl(url) {
			let linkChecklist = '';
			if (url.indexOf('home') > -1 || url == 'checklist') {
				linkChecklist = 'checklist';
			} else {
				linkChecklist = url.substring(1, url.length).replace('checklist-fe', 'checklist');
			}
			vm.linkToChecklist = $sce.trustAsResourceUrl('/' + linkChecklist + '?isHideTopbar');
		}

		function setTabPanelActive() {
			var tabPanel = $(".home-content>.tab-pane.active");
			if (tabPanel) {
				var id = getTabId(tabPanel);
				switch (id) {
					case 'tab1':
						triggerTabClicked('#master-tab', true);
						break;
					case 'tab2':
						triggerTabClicked('#what-new-tab', true);
						break;
					case 'tab3':
						triggerTabClicked('#favorite-tab', true);
						break;
					case 'tab4':
						triggerTabClicked('#reading-list-tab', true);
						break;
					case 'tab5':
						triggerTabClicked('#hearings-tab', true);
						break;
					case 'tab6':
						triggerTabClicked('#checklist-tab', true);
						break;
					case 'tab9':
						triggerTabClicked('#new-annual-cycle-tab', true);
						break;
					default:
						break;
				}
			}

		}

		function getTabId(arrTabPanelActive) {
			for (var i = 0; i < arrTabPanelActive.length; i++) {
				if (arrTabPanelActive[i].id.indexOf('tab') > -1)
					return arrTabPanelActive[i].id;
			}
		}

		$(window).on('resize', function () {
			// This function use to adjust the height of document content/folder content when user try to resize browser viewport.
			// TODO: If we regardless the height of document/folder when user resize browser viewport, we can remove this code.
			var currentTabState = tabStateService.getCurrentTabState();
			if (tabStateService.getCurrentStateType() == tabStateType.homeTabState) {
				if (currentTabState == null) {
					var tabState = localStorageService.getItem(tabStateType.homeTabState);
					currentTabState = tabState;
				}
				tabStateService.adjustContentPosition(currentTabState, tabStateType.homeTabState);
			}
			//Fix for safari When local storage is not enable
			if (HandbookConfiguration.StartpageThemeKey == E.StartpageTheme.Normal) {
				tabStateService.adjustContentHeightHomeStartPageTab();
			}
		});

		function goToAnnualCycle() {
			var path = angular.copy($location.$$url);
			path = path.toLowerCase();
			if (path.indexOf('ac/') > -1) {
				return;
			}
			const url = getBackendUrl();
			var linkAnnualCycle = url + commonAdd + 'ac/home';
			vm.linkAnnualCycle = $sce.trustAsResourceUrl(linkAnnualCycle + '?hideTopBar');
		}

		function goToAnnualCycleFromUrl() {
			var path = angular.copy($location.$$url);
			var linkAnnualCycle = getBackendUrl() + commonAdd + path.substring(1, path.length);
			vm.linkAnnualCycle = $sce.trustAsResourceUrl(linkAnnualCycle + '?hideTopBar');
		}
	};
})();

